import { Button, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React from 'react';
import { SwiperSlide } from 'swiper/react';

// let responsiveLength = "1421";
let responsiveLength = "1000";

let useSyles = makeStyles((theme) => ({
    root: {
        marginTop: 50,
        ...theme.grid.gridLg,
        maxWidth: '100%',
        margin: 'auto',
        minHeight: 450,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            width: '95%',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            minHeight: 525,
            paddingBottom: 40
        },
        [theme.breakpoints.down('501')]: {
            width: '97%',
            paddingBottom: 0
        }
    },
    grid: {
        width: '99%',
        position: 'relative',
        color: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column-reverse',
        }
    },
    gridImages: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '50%',
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            justifyContent: 'center',
        }
    },
    desce: {
        margin: '20px 0px',
        width: 450,
        fontSize: 18,
        [theme.breakpoints.down('1500')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('1250')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('500')]: {
            width: '100%',
            margin: 'auto',
            margin: '20px 0px',
        }
    },
    title: {
        fontSize: 32,
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '100%',
            margin: 'auto',
        }
    },
    gridBtn: {
        width: '94%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            justifyContent: 'space-around',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'center'
        },
        [theme.breakpoints.down(500)]: {
            width: '90%',
            margin: 'auto'
        },

    },
    btnWhite: {
        // width: '40%',
        fontSize: 14,
        backgroundColor: "transparent",
        color: "#ffffff",
        margin: "0px 5px",
        padding: '9px 20px',
        border: `1px solid #ffffff`,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "#ffffff",
            color: "#071b2c !important",
            border: `1px solid transparent`,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            marginTop: 9,
        },
    },
    btnRed: {
        // width: '58%',
        backgroundColor: theme.palette.light.type2,
        color: "white",
        margin: "0px 5px 0px 0px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "white",
            color: "black !important",
            border: `1px solid black`,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            margin: 0
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    gridIconRight: {
        width: 50,
        marginRight: 40,
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            display: 'none',
        }
    },
    gridIconLeft: {
        width: 50,
        marginLeft: 0,
        transform: "rotate(180deg)",
        [theme.breakpoints.down(responsiveLength)]: {
            marginLeft: 0,
            display: 'none',
        }

    },
    icon: {
        width: 50,
    },
    images: {
        maxHeight: 390,
        maxWidth: '100%',
        marginRight: 80,
        [theme.breakpoints.down(1500)]: {
            marginRight: 0,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            maxHeight: 330,
        },
        [theme.breakpoints.down(501)]: {
            maxHeight: 200,
        }
    },
    gridContent: {
        width: '50%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            marginTop: 20,
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
        }
    },
    bgBtn: {
        height: 40,
        width: 40,
        padding: 5,
        backgroundColor: '#132b41',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 9,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
        }
    },
    conentCard: {
        marginLeft: 80,
        [theme.breakpoints.down(1500)]: {
            marginLeft: 0,
        }
    }
}))

export default function Index({ data, flagShowArrow }) {

    let classes = useSyles();

    const base64File = (data) => {
        if (!data) {
            return
        }
        let filetype = data.slice(0, 4);
        if (filetype === "/9j/") {
            return `data:image/jpeg;base64,${data}`
        } else {
            return `data:image/png;base64,${data}`
        }
    }

    const handelButton = (data) => {

        if (data.hidden_title) {
            if (data?.type === 'Link') {
                return (
                    <Button
                        className={  (data.title === "تماس و مشاوره" || data.title === "اطلاعات بیشتر")  ?classes.btnWhite :classes.btnRed}
                        href={data?.hidden_title}
                        target={'_blank'}
                    >
                        {data?.title}
                    </Button>  
                )
            }
            if (data?.type === 'Phone') {
                return (
                    <Button
                        className={classes.btnWhite}
                        href={`tel:${data?.hidden_title}`}
                    >
                        {data?.title}
                    </Button>
                )
            }
        }
    }


    return (
        <div className={classes['root']}>
            <div className={classes['grid']}>
                <div className={classes['gridContent']}>
                    <div className={classes['gridIconRight']}>
                        {/* {
                            flagShowArrow && ( */}
                                <div className={`${classes['bgBtn']} prevNavigation`} onClick={()=>document?.getElementById('prevNavigation')?.click()}>
                                    <svg className={`${classes['icon']} iconsHover`}>
                                        <use xlinkHref={`/sprit.svg#arrow`} >
                                        </use>
                                    </svg>
                                </div>
                            {/* )
                        } */}
                    </div>
                    <div className={classes['conentCard']}>
                        <div>
                            <div className={classes['line']} />
                            <h3 className={classes['title']}>
                                {data?.body?.title}
                            </h3>
                            <p className={classes['desce']}>
                                {data?.body?.description}
                            </p>
                            <div className={classes['gridBtn']}>

                                {
                                    handelButton(data?.body?.first_button)
                                }
                                {
                                    handelButton(data?.body?.second_button)
                                }

                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>
                <div className={classes['gridImages']}>
                    <img src={base64File(data?.body?.image_content)} alt={data?.title} className={classes['images']} />
                    <div className={classes['gridIconLeft']}>
                        {
                            flagShowArrow && (
                                <div className={`${classes['bgBtn']} nextNavigation`} onClick={()=>document?.getElementById('nextNavigation')?.click()}>
                                    <svg className={classes['icon']}>
                                        <use xlinkHref={`/sprit.svg#arrow`} >
                                        </use>
                                    </svg>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div >)
}
